import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import TabTitle from '../_Common/TabTitle';
import { substanceClpFormSelectors } from '../../redux/form/substanceClpForm';

const SubstanceClpTabTitle = props => <TabTitle {...props} />;

const mapStateToProps = state => ({
  title: I18n.t('substance.clp'),
  isDirty: substanceClpFormSelectors.isFormDirty(state),
});

SubstanceClpTabTitle.propTypes = {
  isDirty: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, null)(SubstanceClpTabTitle);
